import React, { useEffect, useState } from 'react';
import { useFetch } from 'hooks/use-fetch';
import AutosuggestBasic from 'layouts/header/search/components/autosuggest-basic';
import SuggestionView from 'layouts/header/search/components/suggestion-view';

import './autosuggest.scss';

const Autosuggest: React.FC<{onSubmit: () => void; onChange: any; searchValue: string; }> = ({ onSubmit, searchValue, onChange }) => {
    const [AutosuggestComponent, setAutosuggestComponent] = useState<React.ComponentType<any>>(() => AutosuggestBasic);
    const { get } = useFetch('/szukaj/typeahead', { method: 'GET' });

    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {
        import('react-autosuggest').then(mod => {
            setAutosuggestComponent(() => mod.default);
        });
    }, []);

    const onSuggestionsFetchRequested = ({ value }: any): void => {
        if (value.length >= 3) {
            get({ query: value }).then((response: any) => {
                if (response) {
                    setSuggestions(response);
                }
            });
        }
    };

    const onSuggestionsClearRequested = (): void => setSuggestions([]);

    const getSuggestionValue = (suggestion: any): string => suggestion.phrase ? suggestion.phrase : '';

    const inputProps = {
        name: 'szukaj',
        placeholder: 'czego szukasz?',
        value: searchValue,
        onChange
    };

    let clearButton;

    if (searchValue && searchValue.length >= 1) {
        clearButton = (
            <button
                type="button"
                className="react-autosuggest__clear-button"
                onClick={(): void => onChange('', { newValue: '' })}
            >
                <i className="icon-clear"/>
            </button>
        );
    }

    return (
        <div className="react-autosuggest">
            <AutosuggestComponent
                suggestions={suggestions}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                onSuggestionsClearRequested={onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={(suggestion: any): any => <SuggestionView suggestion={suggestion}/>}
                inputProps={inputProps}
                onSuggestionSelected={onSubmit}
            />
            { clearButton }
        </div>
    );
};

export default Autosuggest;
